//TODO: Este componente pertenece a los proveedores terrestres del mayorista
import {
    Container,
    Grid,
} from "@material-ui/core"
import HomePage from "../../Home"
import { useDispatch } from "react-redux"
import { Fragment, useEffect } from "react"
import { obtenerTerrestreAllAction } from "../../../ducks/proveedorTerrestreDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import TProveedoresTerrestres from "../TProveedoresTerrestres"
import FProveedoresTerrestres from "../FProveedoresTerrestres"
import FCircuitos from "../FCircuito"
import FPAroveedoresTerrestres from "../FAProveedorTerrestre"
import FPaquetesHoteles from "../FHotelPaqueteTerrestre"
import FPaquetePlaza from "../FPlazaPaqueteTerrestre"
import FPaquetesExtras from "../FExtraPaqueteTerrestre"
import FPaquetesDestinos from "../FCiudadesPaqueteExtra"

const useProvedorTerrestre = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerTerrestreAllAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

const VProveedorTerrestre = () => {
    useProvedorTerrestre()
    return (
        <Fragment>
            <Container maxWidth="xl" style={{ marginTop: "2rem"}}>
                <Grid item xs={12}>
                    <FProveedoresTerrestres />
                </Grid>
                <Grid item xs={12}>
                    <TProveedoresTerrestres />
                </Grid>
                
                <FCircuitos />
                <FPAroveedoresTerrestres />
                <FPaquetesHoteles />
                <FPaquetePlaza />
                <FPaquetesExtras />
                <FPaquetesDestinos />
                
            </Container>
        </Fragment>
    )
}
export default VProveedorTerrestre